export const defaultSettings = {
  height: '20'
};
